export interface InvoiceRequest {
  dateAndTimeOfIssue: string | null;
  invoiceType: InvoiceType;
  transactionType: TransactionType;
  payment: Payment[];
  cashier: string | null;
  buyerID: string | null;
  buyerCostCenterId: string | null;
  invoiceNumber: string | null;
  referentDocumentNumber: string | null;
  referentDocumentDT: string | null;
  items: Item[];
  options: any;
  totalAmount: number;
  totalPayments: number;
}

export enum InvoiceType {
  Unknown = -1,
  Normal = 0,
  Proforma = 1,
  Copy = 2,
  Training = 3,
  Advance = 4
}

export enum TransactionType {
  Unknown = -1,
  Sale = 0,
  Refund = 1
}

export interface Payment {
  amount: number;
  paymentType: PaymentType;
}

export enum PaymentType {
  Unknown = -1,
  Other = 0,
  Cash = 1,
  Card = 2,
  Check = 3,
  WireTransfer = 4,
  Voucher = 5,
  MobileMoney = 6
}

export interface Item {
  gtin?: string;
  name: string;
  quantity: number | null;
  unitPrice: number;
  labels: string[];
  totalAmount: number;
}

/** Opciono polje `options` iz InvoiceRequest-a (kod nas je trenutno `any`).
 *  Generator žurnala čita ova polja defanzivno — nijedno nije obavezno. */
export interface InvoiceOptions {
  buyerName?: string;
  buyerAddress?: string;
  buyerCity?: string;
  headerText?: string;
  footerText?: string;
  remainingAmount?: number;
  /** Kusur (povraćaj). */
  returnAmount?: number;
  /** Željena širina žurnala u karakterima (LPFR koristi ovo kad je > 21). */
  journalCharactersInRow?: number;
}

export interface InvoiceTaxItem {
  /** Poreska oznaka (А, Ђ, Е, Г, ...). */
  label: string;
  /** Naziv poreske kategorije (npr. „ПДВ”). */
  categoryName: string;
  categoryType?: number;
  /** Stopa u procentima (npr. 20). */
  rate: number;
  /** Obračunati iznos poreza. */
  amount: number;
  orderID?: number;
}

/**
 * Odgovor V-PFR-a (`/api/v3/invoices`) koji native shell prosleđuje Angular-u.
 * Native shell uklanja `verificationQRCode` pre slanja (QR se crta iz `verificationUrl`).
 *
 * VAŽNO: polja `businessName`, `locationName`, `address`, `tin`, `district` NE vraća
 * V-PFR odgovor — u LPFR-u se pune iz sertifikata (vidi JournalGenerator napomene).
 */
export interface InvoiceResponse {
  requestedBy?: string;
  signedBy?: string;
  /** ISO 8601, UTC — generator prikazuje u lokalnom vremenu. */
  sdcDateTime?: string;
  /** V-PFR vraća kao string; ako nedostaje računa se iz brojača. */
  invoiceCounter?: string;
  invoiceCounterExtension?: string;
  /** V-PFR vraća kao string; ako nedostaje računa se iz requestedBy/signedBy/totalCounter. */
  invoiceNumber?: string;
  verificationUrl?: string;
  verificationQRCode?: string;
  /** Tekstualni žurnal koji vraća V-PFR (predugačke linije — zato ga regenerišemo). */
  journal?: string;
  totalCounter?: number;
  transactionTypeCounter?: number;
  totalAmount: number;
  encryptedInternalData?: string;
  signature?: string;
  taxItems?: InvoiceTaxItem[];
  // ↓ NE vraća V-PFR — popunjava se iz sertifikata (u eMeni odgovoru nedostaju).
  businessName?: string;
  locationName?: string;
  address?: string;
  tin?: string;
  district?: string;
  taxGroupRevision?: number;
  mrc?: string;
  messages?: string;
}
